import React from 'react';
import { stringifySafe } from '../utils/stringifySafe';

type Props = { value: any; className?: string };
export default function SafePre({ value, className }: Props) {
  return <pre className={className}>{stringifySafe(value)}</pre>;
}